import angular from 'angular';
import opportunityModal from './opportunityModal';
import './style.scss';

export default angular
  .module('components.opportunityModal', [])
  .component('opportunityModal', opportunityModal).name;
